// import React, { useEffect, useState, useMemo, useCallback } from "react";
// import { Nav } from "react-bootstrap";
// import {
//   useLocation,
//   useNavigate,
//   useParams,
//   useSearchParams,
// } from "react-router-dom";
// import { useSelector } from "react-redux";
// import {
//   getUrlDetailsObj,
//   getUserStatsObject,
//   recordActivity,
// } from "../../../services/commonService";
// import { useUser } from "../../../context/UserContext";
// import { COMPANY_LOGO_BASE_URL } from "../../../config/apiConfig";
// import { useDispatch } from "react-redux";

// import "./AccountDetailsTabsV2.css";
// import * as FeatherIcon from "react-feather";
// import CorporateOrgStructure from "./CorporateOrgStructure/CorporateOrgStructure";
// import FinancialPerformance from "./FinancialPerformance/FinancialPerformance";
// import MarketPosition from "./MarketPosition/MarketPosition";
// import ProductInnovations from "./ProductInnovations/ProductInnovations";
// import MarketingDistribution from "./MarketingDistribution/MarketingDistribution";
// import OperationsSupplyChain from "./OperationsSupplyChain/OperationsSupplyChain";
// import NewUpdates from "./NewUpdates/NewUpdates";
// import MarketPositionNew from "./MarketPositionBenchmarkNew/MarketPositionNew";

// function BenchmarkTabs({ displayUpdatesSection }) {
//   const navigate = useNavigate();
//   const dispatch = useDispatch();
//   const { user } = useUser();
//   // console.log("user",user)
//   const { clientName, accountId, competitorName, accountName } = useParams();
//   const pageParsedData = getUrlDetailsObj(useLocation, useParams);
//   const [searchParams, setSearchParams] = useSearchParams();
//   const activeTabFromUrl = searchParams.get("tab") || "corporateOrg";

//   const [activeParentTabKey, setParentActiveTab] = useState(activeTabFromUrl);

//   let corpOrgUpdate = 0;
//   let finPerformanceUpdate = 0;
//   let marPositionUpdate = 0;
//   let proInnovationUpdate = 0;
//   let marDistributionUpdate = 0;
//   let opeSupplyUpdate = 0;

//   useEffect(() => {
//     if (activeTabFromUrl !== activeParentTabKey) {
//       setParentActiveTab(activeTabFromUrl);
//     }
//   }, [activeTabFromUrl]);

//   useEffect(() => {
//     const tabTypeMap = {
//       corporateOrg: "Corporate & Org Structure",
//       financialPerformance: "Financial Performance & Strategy",
//       marketPosition: "Market Position & Intelligence",
//       productInnovation: "Product & Innovation",
//       marketingDistribution: "Marketing & Distribution",
//       operations: "Operations & Supply Chain",
//     };

//     const tabType = tabTypeMap[activeParentTabKey];
//     if (tabType) {
//       pageParsedData.query_params = { tab: activeParentTabKey };
//       const userStat = getUserStatsObject(
//         tabType,
//         "page_load",
//         `Page Source: ${accountName}`,
//         window.location.href,
//         accountId
//       );
//       userStat.url_details = pageParsedData;
//       recordActivity(userStat);
//     }
//   }, [activeParentTabKey]);

//   const handleTabChange = useCallback((key) => {
//     if (
//       [
//         "corporateOrg",
//         "financialPerformance",
//         "marketPosition",
//         "productInnovation",
//         "marketingDistribution",
//         "operations",
//       ].includes(key)
//     ) {
//       setParentActiveTab(key);
//     }
//   }, []);

//   const renderContent = () => {
//     switch (activeParentTabKey) {
//       case "corporateOrg":
//         return <CorporateOrgStructure />;
//       case "financialPerformance":
//         return <FinancialPerformance />;
//       case "marketPosition":
//         return clientName === "H.B. Fuller" ? (
//           <MarketPositionNew />
//         ) : (
//           <MarketPosition />
//         );
//       case "productInnovation":
//         return <ProductInnovations />;
//       case "marketingDistribution":
//         return <MarketingDistribution />;
//       case "operations":
//         return <OperationsSupplyChain />;
//       default:
//         return null;
//     }
//   };

//   const tabItems = useMemo(
//     () => [
//       {
//         key: "corporateOrg",
//         label: "Corporate & Org Structure",
//         icon: (
//           <>
//             <FeatherIcon.Grid
//               className="fa"
//               style={{ width: "16px", marginRight: "7px" }}
//             />
//             {corpOrgUpdate === 1 && <span className="new_dot"></span>}
//           </>
//         ),
//       },
//       {
//         key: "financialPerformance",
//         label: "Financial Performance & Strategy",
//         icon: (
//           <>
//             <FeatherIcon.Briefcase
//               className="fa"
//               style={{ width: "16px", marginRight: "7px" }}
//             />
//             {finPerformanceUpdate === 1 && <span className="new_dot"></span>}
//           </>
//         ),
//       },
//       {
//         key: "marketPosition",
//         label: "Market Position & Intelligence",
//         icon: (
//           <>
//             <FeatherIcon.Target
//               className="fa"
//               style={{ width: "16px", marginRight: "7px" }}
//             />
//             {marPositionUpdate === 1 && <span className="new_dot"></span>}
//           </>
//         ),
//       },
//       {
//         key: "productInnovation",
//         label: "Product & Innovation",
//         icon: (
//           <>
//             <FeatherIcon.Calendar
//               className="fa"
//               style={{ width: "16px", marginRight: "7px" }}
//             />
//             {proInnovationUpdate === 1 && <span className="new_dot"></span>}
//           </>
//         ),
//       },
//       {
//         key: "marketingDistribution",
//         label: "Marketing & Distribution",
//         icon: (
//           <>
//             {/* <FeatherIcon.BookOpen
//               className="fa"
//               style={{ width: "16px", marginRight: "7px" }}
//             /> */}
//             <img
//               src="/img/marketing_distribution_icon.png"
//               alt={"icon"}
//               className={`filter_icon`}
//               style={{ width: "16px", marginRight: "7px" }}
//             />
//             {marDistributionUpdate === 1 && <span className="new_dot"></span>}
//           </>
//         ),
//       },
//       {
//         key: "operations",
//         label: "Operations & Supply Chain",
//         icon: (
//           <>
//             {/* <FeatherIcon.Shuffle
//               className="fa"
//               style={{ width: "16px", marginRight: "7px" }}
//             /> */}

//             <img
//               src="/img/operation_supply_chain_icon.png"
//               alt={"icon"}
//               className={`filter_icon`}
//               style={{ width: "16px", marginRight: "7px" }}
//             />
//             {opeSupplyUpdate === 1 && <span className="new_dot"></span>}
//           </>
//         ),
//       },
//     ],
//     []
//   );

//   const handleBackToAccounts = () => {
//     navigate("/watchboard");
//   };

//   return (
//     <div className="account-details-container">
//       {/* Sidebar */}
//       <div className="account-details-container-sidecard-container">
//         <div className="sidebar_left_container">
//           <Nav className="account-tabs-nav" style={{ position: "absolute" }}>
//             {/* <div className='search_tab_block'>
//                 <div className="search_tab_subblock">
//                 <FeatherIcon.Search className='search_feather'/>
//                   <input
//                     type="search"
//                     autoComplete='off'
//                     placeholder="Search"
//                     className='search_tab_input'
//                   />
//                 </div>
//             </div> */}

//             {tabItems.map((tab) => (
//               <Nav.Link
//                 className="account-tab-item"
//                 key={tab.key}
//                 active={activeParentTabKey === tab.key}
//                 onClick={() => handleTabChange(tab.key)}
//               >
//                 <div className="account-tab-item-content">
//                   <span className="icon_left_sub">{tab.icon}</span>
//                   {tab.label}
//                 </div>
//               </Nav.Link>
//             ))}
//           </Nav>
//         </div>
//       </div>

//       {/* Content Area */}
//       <div className="account-details-container-content">
//         {displayUpdatesSection && <NewUpdates />}
//         {renderContent()}
//       </div>
//     </div>
//   );
// }

// export default React.memo(BenchmarkTabs);

import React, {
  useEffect,
  useState,
  useMemo,
  useCallback,
  useRef,
} from "react";
import { Nav } from "react-bootstrap";
import {
  useLocation,
  useNavigate,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  getUrlDetailsObj,
  getUserStatsObject,
  recordActivity,
} from "../../../services/commonService";
import { useUser } from "../../../context/UserContext";
import "./AccountDetailsTabsV2.css";
import * as FeatherIcon from "react-feather";

import CorporateOrgStructure from "./CorporateOrgStructure/CorporateOrgStructure";
import FinancialPerformance from "./FinancialPerformance/FinancialPerformance";
import MarketPosition from "./MarketPosition/MarketPosition";
import ProductInnovations from "./ProductInnovations/ProductInnovations";
import MarketingDistribution from "./MarketingDistribution/MarketingDistribution";
import OperationsSupplyChain from "./OperationsSupplyChain/OperationsSupplyChain";
import NewUpdates from "./NewUpdates/NewUpdates";
import MarketPositionNew from "./MarketPositionBenchmarkNew/MarketPositionNew";
import MarketPositionNew2 from "./MarketPositionBenchmarkNew/MarketPositionNew2";
import MarketPositionHBFULLER from "./MarketPositionBenchmarkNew/MarketPositionHBFULLER";

function BenchmarkTabs({
  displayUpdatesSection,
  activeParentTabKey,
  setParentActiveTab,
}) {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { user } = useUser();
  const { clientName, accountId, accountName } = useParams();
  const location = useLocation();
  const pageParsedData = getUrlDetailsObj(useLocation, useParams);
  const [searchParams, setSearchParams] = useSearchParams();

  const activeTabFromUrl = searchParams.get("tab") || "corporateOrg";
  // const [activeParentTabKey, setParentActiveTab] = useState(activeTabFromUrl);
  const [activeSubKey, setActiveSubKey] = useState(activeTabFromUrl);
  const [expandedKeys, setExpandedKeys] = useState({});

  // ++++++++++++++++++++++++++++++++++++++++++++++
  const [searchText, setSearchText] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const [scrollTarget, setScrollTarget] = useState(null);
  const sectionMap = useRef({});
  const programmaticScrollRef = useRef(null);

  // ++++++++++++++++++++++++++++++++++++++++++++++

  // ------------------ Keep tab in sync with URL ------------------
  useEffect(() => {
    const tabFromUrl = searchParams.get("tab") || activeParentTabKey;
    setActiveSubKey(tabFromUrl);
  }, [searchParams, activeParentTabKey]);

  useEffect(() => {
    if (activeTabFromUrl !== activeParentTabKey) {
      if (activeTabFromUrl !== null) {
        setActiveSubKey(activeTabFromUrl);
      } else {
        setParentActiveTab(activeTabFromUrl);
      }
    }
  }, [activeTabFromUrl]);

  const handleSetActiveSubKey = useCallback(
    (key) => {
      setActiveSubKey(key);
      setSearchParams({ tab: key });
    },
    [setSearchParams]
  );

  const toggleExpand = (key) => {
    setExpandedKeys((prev) => {
      const isExpanded = !!prev[key];
      return isExpanded ? {} : { [key]: true }; // collapse all except this
    });
  };

  // TAB/SUB-TABS

  const corpOrgStrTabs = [
    "insightSummaryTabB",
    "companyOverviewTab",
    "headquartersTab",
    "ownershipStructureTab",
    "executiveTeamTab",
    "workforceTab",
  ];

  const marketPositionTabs = [
    "executiveOverviewMpNewTab",
    "marketPositionNewTab",
    "customerIntelligenceTab",
  ];

  // ------------------ Record Activity ------------------
  useEffect(() => {
    const tabTypeMap = {
      corporateOrg: "Corporate & Org Structure",
      financialPerformance: "Financial Performance & Strategy",
      marketPosition: "Market Position & Intelligence",
      productInnovation: "Product & Innovation",
      marketingDistribution: "Marketing & Distribution",
      operations: "Operations & Supply Chain",
    };

    const tabType = tabTypeMap[activeParentTabKey];
    if (tabType) {
      pageParsedData.query_params = { tab: activeParentTabKey };
      const userStat = getUserStatsObject(
        tabType,
        "page_load",
        `Page Source: ${accountName}`,
        window.location.href,
        accountId
      );
      userStat.url_details = pageParsedData;
      recordActivity(userStat);
    }
  }, [activeParentTabKey]);

  // ------------------ Tab Items (ready for children later) ------------------
  const tabItems = useMemo(
    () => [
      {
        key: "corporateOrg",
        label: "Corporate & Org Structure",
        icon: (
          <FeatherIcon.Grid style={{ width: "16px", marginRight: "7px" }} />
        ),
        activeIcon: (
          <FeatherIcon.Grid
            style={{ width: "16px", marginRight: "7px", color: "#007bff" }}
          />
        ),
        children: [
          { key: "insightSummaryTabB", label: "Insight Summary" },
          { key: "companyOverviewTab", label: "Company Overview" },
          {
            key: "headquartersTab",
            label: "Headquarters & Business Segments",
          },
          { key: "ownershipStructureTab", label: "Ownership & Structure" },
          { key: "executiveTeamTab", label: "Executive Team & Key Leadership" },
          { key: "workforceTab", label: "Workforce & Hiring Trends" },
        ],
      },
      {
        key: "financialPerformance",
        label: "Financial Performance & Strategy",
        icon: (
          <FeatherIcon.Briefcase
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        activeIcon: (
          <FeatherIcon.Briefcase
            style={{ width: "16px", marginRight: "7px", color: "#007bff" }}
          />
        ),
      },
      {
        key: "marketPosition",
        label: "Market Position & Intelligence",
        icon: (
          <FeatherIcon.Target style={{ width: "16px", marginRight: "7px" }} />
        ),
        activeIcon: (
          <FeatherIcon.Target
            style={{ width: "16px", marginRight: "7px", color: "#007bff" }}
          />
        ),
        children: [
          { key: "executiveOverviewMpNewTab", label: "Executive Overview" },
          { key: "marketPositionNewTab", label: "Market Position" },
          { key: "customerIntelligenceTab", label: "Customer Intelligence" },
        ],
      },
      {
        key: "productInnovation",
        label: "Product & Innovation",
        icon: (
          <FeatherIcon.Calendar style={{ width: "16px", marginRight: "7px" }} />
        ),
        activeIcon: (
          <FeatherIcon.Calendar
            style={{ width: "16px", marginRight: "7px", color: "#007bff" }}
          />
        ),
      },
      {
        key: "marketingDistribution",
        label: "Marketing & Distribution",
        icon: (
          <img
            src="/img/marketing_distribution_icon.png"
            alt="icon"
            className="filter_icon"
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        activeIcon: (
          <img
            src="/img/marketing_distribution_icon_blue.png"
            alt="icon"
            className="filter_icon"
            style={{
              width: "17px",
              marginRight: "7px",
              // filter:
              //   "invert(33%) sepia(93%) saturate(2000%) hue-rotate(200deg)",
            }}
          />
        ),
      },
      {
        key: "operations",
        label: "Operations & Supply Chain",
        icon: (
          <img
            src="/img/operation_supply_chain_icon.png"
            alt="icon"
            className="filter_icon"
            style={{ width: "16px", marginRight: "7px" }}
          />
        ),
        activeIcon: (
          <img
            src="/img/operation_supply_chain_icon_blue.png"
            alt="icon"
            className="filter_icon"
            style={{
              width: "17px",
              marginRight: "7px",
              // filter:
              //   "invert(33%) sepia(93%) saturate(2000%) hue-rotate(200deg)",
            }}
          />
        ),
      },
    ],
    []
  );

  // ------------------ Handle Tab Change ------------------
  const handleTabChange = useCallback(
    (key, hasChildren = false) => {
      const parentTabs = [
        "corporateOrg",
        "financialPerformance",
        "marketPosition",
        "productInnovation",
        "marketingDistribution",
        "operations",
      ];

      if (parentTabs.includes(key)) {
        // direct parent tab click
        setParentActiveTab(key);
        // setSearchParams({ tab: key });
        handleSetActiveSubKey(key);

        if (hasChildren && tabItems) {
          const parent = tabItems.find((t) => t.key === key);
          const firstChildKey = parent?.children?.[0]?.key;

          if (firstChildKey) {
            handleSetActiveSubKey(firstChildKey); // set first child as active
          }

          setExpandedKeys((prev) => {
            const isExpanded = prev[key]; // check if it's currently expanded
            return isExpanded ? {} : { [key]: true }; // collapse if expanded, otherwise expand
          });
        } else {
          handleSetActiveSubKey(key); // no children → set parent as active
          setExpandedKeys({}); // collapse all
        }
      } else {
        // subtab click → figure out its parent

        if (corpOrgStrTabs.includes(key)) {
          setParentActiveTab("corporateOrg");
          setExpandedKeys({ corporateOrg: true });
        } else if (marketPositionTabs.includes(key)) {
          setParentActiveTab("marketPosition");
          setExpandedKeys({ marketPosition: true });
        }

        // setSearchParams({ tab: key });
        handleSetActiveSubKey(key);
      }
    },
    [handleSetActiveSubKey]
  );

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++
  // SEARCH FUNCTIONALITY
  // +++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // Build searchable sections from all tabs
  const buildSearchIndex = useCallback(() => {
    const searchIndex = [];

    tabItems.forEach((tab) => {
      // Add parent tab to search
      searchIndex.push({
        key: tab.key,
        label: tab.label,
        parentKey: null,
        parentLabel: null,
      });

      // Add children to search
      if (tab.children && tab.children.length > 0) {
        tab.children.forEach((child) => {
          searchIndex.push({
            key: child.key,
            label: child.label,
            parentKey: tab.key,
            parentLabel: tab.label,
          });
        });
      }
    });

    return searchIndex;
  }, [tabItems]);

  // Search handler
  const handleSearch = useCallback(
    (value) => {
      setSearchText(value);

      if (!value.trim()) {
        setSearchResults([]);
        setShowSuggestions(false);
        return;
      }

      const searchIndex = buildSearchIndex();
      const searchTerm = value.toLowerCase();

      const results = searchIndex.filter((item) => {
        const labelMatch = item.label.toLowerCase().includes(searchTerm);
        const parentMatch = item.parentLabel
          ?.toLowerCase()
          .includes(searchTerm);
        return labelMatch || parentMatch;
      });

      setSearchResults(results);
      setShowSuggestions(results.length > 0);
    },
    [buildSearchIndex]
  );

  // Handle suggestion click
  const handleSuggestionClick = useCallback(
    (item) => {
      // Close suggestions dropdown
      setShowSuggestions(false);
      setSearchText("");
      setSearchResults([]);

      // Navigate to the selected tab/section
      handleTabChange(item.key);

      // Set scroll target for child component to handle
      setScrollTarget({
        key: item.key,
        timestamp: Date.now(), // ensures fresh scroll even if same key
      });
    },
    [handleTabChange]
  );

  // Click outside to close suggestions
  useEffect(() => {
    const handleClickOutside = (event) => {
      const searchBlock = document.querySelector(".search_tab_block");
      if (searchBlock && !searchBlock.contains(event.target)) {
        setShowSuggestions(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  // ++++++++++++++++++++++++++++++++++++++++++++++++++++++

  // ------------------ Render Content ------------------
  // const renderContent = () => {
  //   const currentTab = searchParams.get("tab") || activeParentTabKey;

  //   // define subtabs mapping here (inside renderContent, so they’re in scope)

  //   // normalize parent key
  //   let normalizedParent = activeParentTabKey;
  //   if (corpOrgStrTabs.includes(currentTab)) {
  //     normalizedParent = "corporateOrg";
  //   } else if (marketPositionTabs.includes(currentTab)) {
  //     normalizedParent = "marketPosition";
  //   }

  //   switch (normalizedParent) {
  //     case "corporateOrg":
  //       return (
  //         <CorporateOrgStructure
  //           activeSubKey={activeSubKey}
  //           setActiveSubKey={setActiveSubKey}
  //         />
  //       );
  //     case "financialPerformance":
  //       return <FinancialPerformance />;

  //     case "marketPosition":
  //       if (clientName === "Nvent") {
  //         return (
  //           <MarketPositionNew2
  //             activeSubKey={activeSubKey}
  //             setActiveSubKey={setActiveSubKey}
  //           />
  //         );
  //       } else if (clientName === "Stryker") {
  //         return (
  //           <MarketPositionNew
  //             activeSubKey={activeSubKey}
  //             setActiveSubKey={setActiveSubKey}
  //           />
  //         );
  //       } else if (clientName === "H.B. Fuller") {
  //         return (
  //           <MarketPositionHBFULLER
  //             activeSubKey={activeSubKey}
  //             setActiveSubKey={setActiveSubKey}
  //           />
  //         );
  //       } else
  //         return (
  //           <MarketPosition
  //             activeSubKey={activeSubKey}
  //             setActiveSubKey={setActiveSubKey}
  //           />
  //         );

  //     case "productInnovation":
  //       return <ProductInnovations />;
  //     case "marketingDistribution":
  //       return <MarketingDistribution />;
  //     case "operations":
  //       return <OperationsSupplyChain />;
  //     default:
  //       return null;
  //   }
  // };
  // ------------------ Render Content ------------------
  const renderContent = () => {
    const currentTab = searchParams.get("tab") || activeParentTabKey;

    // normalize parent key
    let normalizedParent = activeParentTabKey;
    if (corpOrgStrTabs.includes(currentTab)) {
      normalizedParent = "corporateOrg";
    } else if (marketPositionTabs.includes(currentTab)) {
      normalizedParent = "marketPosition";
    }

    switch (normalizedParent) {
      case "corporateOrg":
        return (
          <CorporateOrgStructure
            activeSubKey={activeSubKey}
            setActiveSubKey={setActiveSubKey}
            scrollTarget={scrollTarget}
          />
        );
      case "financialPerformance":
        return <FinancialPerformance scrollTarget={scrollTarget} />;

      case "marketPosition":
        if (clientName === "Nvent Co.") {
          return (
            <MarketPositionNew2
              activeSubKey={activeSubKey}
              setActiveSubKey={setActiveSubKey}
              scrollTarget={scrollTarget}
            />
          );
        } else if (clientName === "Stryker") {
          return (
            <MarketPositionNew
              activeSubKey={activeSubKey}
              setActiveSubKey={setActiveSubKey}
              scrollTarget={scrollTarget}
            />
          );
        } else if (clientName === "H.B. Fuller") {
          return (
            <MarketPositionHBFULLER
              activeSubKey={activeSubKey}
              setActiveSubKey={setActiveSubKey}
              scrollTarget={scrollTarget}
            />
          );
        } else {
          return (
            <MarketPosition
              activeSubKey={activeSubKey}
              setActiveSubKey={setActiveSubKey}
              scrollTarget={scrollTarget}
            />
          );
        }

      case "productInnovation":
        return <ProductInnovations scrollTarget={scrollTarget} />;
      case "marketingDistribution":
        return <MarketingDistribution scrollTarget={scrollTarget} />;
      case "operations":
        return <OperationsSupplyChain scrollTarget={scrollTarget} />;
      default:
        return null;
    }
  };

  return (
    <div className="account-details-container">
      {/* Sidebar */}
      <div className="account-details-container-sidecard-container">
        {/* SEARCH BLOCK START */}
        <div className="search_tab_block mr-4">
          <div className="search_tab_subblock m-2">
            <FeatherIcon.Search className="search_feather" />
            <input
              type="search"
              autoComplete="off"
              placeholder="Search"
              className="search_tab_input"
              value={searchText}
              onChange={(e) => handleSearch(e.target.value)}
              onFocus={() => setShowSuggestions(true)}
            />
          </div>

          {showSuggestions && searchResults.length > 0 && (
            <div className="tab-search-suggestions notify-popup">
              <div
                style={{
                  borderBottom: "1px solid #E2E8F0",
                  color: "#4E6BCA",
                  fontWeight: "500",
                  fontSize: "12px",
                  padding: "16px",
                }}
              >
                Showing {searchResults.length} results
              </div>
              <div className="notify-list">
                {searchResults.map((item) => (
                  <div
                    key={item.key}
                    className="tab-search-item notify-item"
                    onClick={() => handleSuggestionClick(item)}
                  >
                    <span className="tab-search-label info name">
                      {item.parentLabel && (
                        <>
                          {item.parentLabel}{" "}
                          <FeatherIcon.ChevronRight width="16" height="16" />
                        </>
                      )}
                      <strong>{item.label}</strong>
                    </span>
                  </div>
                ))}
              </div>
            </div>
          )}
        </div>
        {/* END SEARCH BLOCK */}

        <div className="sidebar_left_container">
          <Nav className="account-tabs-nav">
            {tabItems.map((tab) => (
              <div key={tab.key}>
                <Nav.Link
                  className="account-tab-item"
                  active={activeParentTabKey === tab.key}
                  onClick={() => handleTabChange(tab.key, !!tab.children)}
                >
                  <div
                    className={`account-tab-item-content ${
                      activeParentTabKey === tab.key ? "blue_top" : ""
                    }`}
                  >
                    <span className="icon_left_sub">
                      {activeParentTabKey === tab.key
                        ? tab.activeIcon
                        : tab.icon}
                    </span>
                    {tab.label}
                    {tab.children && (
                      <span className="dropdown-arrow">
                        {expandedKeys[tab.key] ? (
                          <FeatherIcon.ChevronRight width="16" height="16" />
                        ) : (
                          <FeatherIcon.ChevronDown width="16" height="16" />
                        )}
                      </span>
                    )}
                  </div>
                </Nav.Link>

                {/* Ready for future child expansion */}
                {tab.children?.length > 0 && expandedKeys[tab.key] && (
                  <div className="submenu">
                    {tab.children.map((child) => (
                      <div
                        key={child.key}
                        className={`submenu-item ${
                          activeSubKey === child.key ? "active blue" : ""
                        }`}
                        onClick={() => {
                          handleTabChange(child.key);
                          setExpandedKeys({ [tab.key]: true });
                        }}
                      >
                        {child.label}
                      </div>
                    ))}
                  </div>
                )}
              </div>
            ))}
          </Nav>
        </div>
      </div>

      {/* Content Area */}
      <div className="account-details-container-content">
        {displayUpdatesSection && <NewUpdates />}
        {renderContent()}
      </div>
    </div>
  );
}

export default React.memo(BenchmarkTabs);
